{{yearStr()}}
<span matTooltip="{{tooltip()}}">{{emoji()}}</span>
{{rankStr()}}
<span *ngIf="!hideNew && isNew()" matTooltip="New for {{year}}">🆕</span>
